module.exports = __webpack_public_path__ + "static/media/bed-bunk.4688e0f5.svg";